<template>
  <van-dialog title="升级会员" v-model="show" :show-cancel-button="true" cancel-button-text="取消" confirm-button-text="确定" type="danger" class-name="pc-dialog pc-gg-dialog" :before-close="handleSubmit">
    <div class="setting-component-container">
      <div class="form-item">
        <el-form :model="form" :rules="rules" ref="dialogForm" label-width="86px" label-position="left">
          <el-form-item label="会员等级"  prop="Level">
            <el-select v-model="form.Level" style="width: 100%;">
              <el-option v-for="(item, index) in vipList" :key="index" :label="item.Name" :value="item.Level"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  emits: ['success', 'close'],
  name: "PcVipUpgradeComponent",
  data() {
    return {
      show: false,
      vipList: [],
      form: {
        Level: '',
      },
      rules: {
        Level: [
          {required: true, message: '请选择的会员等级'}
        ]
      },
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  methods: {
    open() {
      this.show = true
      this.handleGetVipList()
    },
    async handleGetVipList() {
      var res = await this.$API.vipMoney.post({
        Type: 1
      })
      if (res && res.length > 0) {
        this.vipList = res
      }
    },
    async handleSubmit(action, done) {
      if (action == 'cancel') {
        this.$emit('close')
        done()
        return
      }
      if (action == 'confirm') {
        if (this.submiting) {
          return
        }
        this.$refs.dialogForm.validate(async (valid) => {
          if (valid) {
            const { form } = this
            const params = {
              ...form
            }
            this.submiting = true
            var res = await this.$API.buyVip.post(params)
            this.submiting = false
            if (res.error == 0) {
              this.$toast.success(res.info)
              this.show = false
              this.$emit('success')
              done()
            } else {
              this.$dialog.alert({
                type: 'danger',
                className: 'pc-dialog',
                title: '提示',
                message: res.info,
                confirmButtonText: '确定',
              })
            }
          } else {
            done(false)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.setting-component-container {
  padding: 0 15px;
}
</style>